import { Component, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { MessageService } from 'primeng/api';
import { DialogService } from '../../../../services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ContractService } from '../service/contract.service';
import { PhoneNumberInputComponent } from '../../../../components/phone-number-input/phone-number-input.component';

@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrl: './config.component.scss'
})
export class ConfigComponent {
   tabTriangle:string='company';
     tableTrVar:any=null;
     spinner:boolean=false;
     myOptions!:object;
     showUpdateButton:boolean=false;
     metricFullscreen:boolean=false;
     rfpconfigFrom:FormGroup=new FormGroup({});
     companyconfigFrom:FormGroup = new FormGroup({});
     relationshipconfigFrom:FormGroup = new FormGroup({});
     lobconfigFrom:FormGroup=new FormGroup({});
     sicCodeconfigFrom:FormGroup=new FormGroup({});
     submitted = false;
     client_id:any;
     companyRelationshipList:any[]=[];
     companyListData:any[]=[];
      lobListData:any[]=[];
      sicListData:any[]=[];
     selectedRelationshipId:any;
     selectedCompanyId:any;
     selectedLobId:any;
     selectedSicId:any;
     clientList:any[]=[];
     bodySpinner:boolean=false;
     currentUserDetail:any;
     isModalVisible:boolean=false;
     seletedModal:any=null;
     popLoader:boolean=false;
      initContry:any;
       private readonly notifier: NotifierService;
         @ViewChild('phoneComp') phoneComp!: PhoneNumberInputComponent;
     constructor( private notifierService: NotifierService,private fb:FormBuilder,private messageService: MessageService,private infosecService:ContractService,private dialogService:DialogService,private renderer:Renderer2){
       this.notifier = notifierService;
     }
  
     ngOnInit(){
      // this.rfpconfigFrom = this.fb.group({
      //   'type_name':['',[Validators.required,Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]],
      //   'description':['',[Validators.required,Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]],
      //   'is_active':[true]
      // });
      this.companyconfigFrom = this.fb.group({
        'client_id':[''],
        'company_name':['',[Validators.required]],
        'company_relationship_id':[null,Validators.required],
        'description':[''],
        'company_details':['',[Validators.required]],
        'is_active':[true,Validators.required],
        'contact_person':['',[Validators.required]],
        'contact_number':[''],
        'contact_email':['',[Validators.required,Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
        'lob_ids':[null],
        "sic_ids":[null]
      });
  
      this.relationshipconfigFrom = this.fb.group({
        'client_id':[''],
        'relationship_name':['',[Validators.required,Validators.pattern(/^[A-Za-z0-9\s\&\-]*$/)]],
        'description':['',[Validators.required,Validators.pattern(/^[A-Za-z0-9\s\&\-\.]*$/)]],
        'is_active':[true,Validators.required]
      });
       this.lobconfigFrom = this.fb.group({
        'client_id':[''],
        'lob_name':['',[Validators.required,Validators.pattern(/^[A-Za-z0-9\s\&]*$/)]],
        'description':['',[Validators.required,Validators.pattern(/^[A-Za-z0-9\s\&\-\_\'\,\.]*$/)]],
        'is_active':[true,Validators.required]
      });
      this.sicCodeconfigFrom = this.fb.group({
        'client_id':[''],
        'sic_code':['',[Validators.required,Validators.pattern(/^\d+$/)]],
        'sic_office':['',[Validators.required,Validators.pattern(/^[A-Za-z0-9\s\'\,\&]*$/)]],
        'sic_title':['',[Validators.required,Validators.pattern(/^[A-Za-z0-9\s\'\-\&]*$/)]],
        'description':['',[Validators.required,Validators.pattern(/^[A-Za-z0-9\s\'\&\,\-\.]*$/)]],
        'is_active':[true,Validators.required]
      });
      this.infosecService.getClient().subscribe(
        (response:any)=>{
           if(response.length > 0){
               this.clientList = response;
               this.client_id=this.clientList[0]['id'];
               this.companyconfigFrom.controls['client_id'].setValue(this.client_id);
               this.relationshipconfigFrom.controls['client_id'].setValue(this.client_id);
               this.lobconfigFrom.controls['client_id'].setValue(this.client_id);
               this.sicCodeconfigFrom.controls['client_id'].setValue(this.client_id);
           }
        },
        (error:HttpErrorResponse)=>{
  
        }); 
      this.bodySpinner=true;
      this.getRelationship();
      this.getCompanyList();
      this.getLob();
      this.getSICCode();
      this.infosecService.getCurrentUser().subscribe({
            next:(response:any)=>{
              this.currentUserDetail = response;
             },
            error:(errors:HttpErrorResponse)=>{}
          });
  
       
     }
     showTriangle(tab:any){
      this.tabTriangle=tab;
     }
  
  
     tableBack(index:any){
  
     }
  
     getRelationship(){
      this.infosecService.getCompanyRelationship().subscribe({
        next:(response:any)=>{
           this.companyRelationshipList = response['result'];
           this.bodySpinner = false;
        },
        error:(errors:HttpErrorResponse)=>{
           this.bodySpinner = false;
             // this.messageService.add({ severity: 'info', summary: 'info', detail: errors['error']['message'], life: 3000 });
              this.notifier.notify('default',errors.error['message']);
        }
      });
     }
  
     getCompanyList(){
      this.infosecService.getCompanies().subscribe({
        next:(response:any)=>{
           this.companyListData = response['result'];
              this.bodySpinner = false;
        },
        error:(errors:HttpErrorResponse)=>{
           this.bodySpinner = false;
        }
      })
     }
  
  
     getLob(){
       this.infosecService.getLob().subscribe({
        next:(response:any)=>{
          this.lobListData = response['result'];
        },
        error:(errors:HttpErrorResponse)=>{
  
        }
       });
     }
  
     getSICCode(){
       this.infosecService.getSICCode().subscribe({
         next:(response:any)=>{
          this.sicListData = response['result'];
         },
         error:(errors:HttpErrorResponse)=>{}
       });
     }
  
      
  
     saveRelationship(){
        this.submitted = true;
        this.relationshipconfigFrom.value['client_id']=this.client_id;
      this.rfpconfigFrom.markAllAsTouched();
      this.rfpconfigFrom.markAsDirty();
  
      if(this.relationshipconfigFrom.valid){
        this.popLoader=true;
        this.infosecService.createCompanyRelationship(this.relationshipconfigFrom.value).subscribe({
          next:(response:any)=>{
             this.submitted=false;
             this.isModalVisible=false;
             this.relationshipconfigFrom.reset();
  
             this.getRelationship();
            this.notifier.notify('default','Created Successfully');
            },
            error:(errors:HttpErrorResponse)=>{
               this.submitted=false;
                this.popLoader=true;
                this.notifier.notify('default',errors.error['message']);
            }
          });
      }
  
     }
  
    selectRelationship(relationship:any){
      this.selectedRelationshipId= relationship['id'];
      this.relationshipconfigFrom.patchValue(relationship);
      // let companyRelationshipDetails = this.companyRelationshipList[index];
      // console.log(companyRelationshipDetails);
      // this.relationshipconfigFrom.controls['relationship_name'].setValue(companyRelationshipDetails['relationship_name']);
      // this.relationshipconfigFrom.controls['description'].setValue(companyRelationshipDetails['description']);
      // this.relationshipconfigFrom.controls['is_active'].setValue(companyRelationshipDetails['is_active']);
      this.showUpdateButton = true;
      this.OpenModal("relationship","edit");
      this.isModalVisible=true;
    }
  
    selectCompany(company:any){
      this.OpenModal("company","edit");
      this.selectedCompanyId = company['id'];
      // let companyDetails = company;
      // delete companyDetails['id'];
      this.companyconfigFrom.patchValue(company);
      this.showUpdateButton = true;
      this.isModalVisible=true;
    }
    
  
    updateRelationshipForm(){
      this.submitted=true;
      this.relationshipconfigFrom.markAllAsTouched();
      this.relationshipconfigFrom.markAsDirty();
       this.relationshipconfigFrom.value['client_id']=this.client_id;
      if(this.relationshipconfigFrom.valid){
         this.popLoader=true;
          this.infosecService.updateCompanyRelationship(this.relationshipconfigFrom.value,this.selectedRelationshipId).subscribe({
            next:(response:any)=>{
              this.isModalVisible=false;
              this.relationshipconfigFrom.reset();
              this.notifier.notify('default','Updated Successfully');
               this.getRelationship();
            },
            error:(errors:HttpErrorResponse)=>{
              this.popLoader=false;
               this.notifier.notify('default',errors.error['message']);
            }
          });
      }
    }
  
     exitIconReset(){
       this.submitted = false;
       // this.companyconfigFrom.reset();
        this.relationshipconfigFrom.reset();
        this.lobconfigFrom.reset();
        this.sicCodeconfigFrom.reset();
        this.showUpdateButton = false;
        this.isModalVisible=false;
       
     }
  
     saveCompany(){
      this.submitted=true;
    this.companyconfigFrom.value['client_id']=this.client_id;
    this.companyconfigFrom.markAsDirty();
    this.companyconfigFrom.markAllAsTouched();
      if(this.companyconfigFrom.valid){
          this.popLoader=true;
         this.infosecService.createCompanies(this.companyconfigFrom.value).subscribe({
          next:(response:any)=>{
             this.submitted=false;
             this.popLoader=false;
             this.isModalVisible=false;
              this.companyconfigFrom.reset();
                // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Created Successfully', life: 3000 });
                 this.notifier.notify('default','Created Successfully');
                this.getCompanyList();
            },
        error:(errors:HttpErrorResponse)=>{
           this.submitted=false;
            this.popLoader=false;
            this.notifier.notify('default',errors.error['message']);
            //this.messageService.add({ severity: 'info', summary: 'info', detail: errors['error']['message'], life: 3000 });
        }});
      }
  
     }
     updateCompany(){
       this.submitted=true;
       this.companyconfigFrom.markAsDirty();
       this.companyconfigFrom.markAllAsTouched();
         this.companyconfigFrom.value['client_id']=this.client_id;
        if(this.companyconfigFrom.valid){
          this.submitted=false;
          this.popLoader=true;
          this.companyconfigFrom.controls['description'].setValue('');
          this.companyconfigFrom.value['company_relationship_id'] = parseInt(this.companyconfigFrom.value['company_relationship_id']);
          this.infosecService.updateCompanies(this.companyconfigFrom.value,this.selectedCompanyId).subscribe({
            next:(response:any)=>{
               this.submitted=false;
              
               this.isModalVisible=false;
                this.companyconfigFrom.reset();
             // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully', life: 3000 });
              this.notifier.notify('default','Updated Successfully');
               this.getCompanyList();
            },
            error:(errors:HttpErrorResponse)=>{
               this.submitted=false;
               this.popLoader=false;
                this.notifier.notify('default',errors.error['message']);
             // this.messageService.add({ severity: 'info', summary: 'info', detail: errors['error']['message'], life: 3000 });
            }
          });
        }
     }
  
     saveLOB(){
       this.submitted=true;
       this.lobconfigFrom.value['client_id']=this.client_id;
       this.lobconfigFrom.markAsDirty();
       this.lobconfigFrom.markAllAsTouched();
      if(this.lobconfigFrom.valid){
        this.popLoader=true;
         this.infosecService.createLob(this.lobconfigFrom.value).subscribe({
          next:(response:any)=>{
             this.submitted=false;
             this.isModalVisible=false;
                // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Created Successfully', life: 3000 });
                 this.notifier.notify('default','Created Successfully');
                 this.lobconfigFrom.reset();
                 this.getLob();
            },
        error:(errors:HttpErrorResponse)=>{
           this.submitted=false;
            this.popLoader=false;
            this.notifier.notify('default',errors.error['message']);
            //this.messageService.add({ severity: 'info', summary: 'info', detail: errors['error']['message'], life: 3000 });
        }});
      }
     }
  
      selectLob(lob:any){
      this.selectedLobId= lob['id'];
      this.lobconfigFrom.patchValue(lob);
      this.OpenModal("lob","edit");
      this.showUpdateButton = true;
     }
  
      selectSICCode(sic:any){
      this.selectedSicId= sic['id'];
      this.sicCodeconfigFrom.patchValue(sic);
      this.OpenModal("sic","edit");
      this.showUpdateButton = true;
     }
  
     updateLOB(){
        this.submitted=true;
         this.lobconfigFrom.value['client_id']=this.client_id;
         this.lobconfigFrom.markAllAsTouched();
         this.lobconfigFrom.markAsDirty();
      if(this.lobconfigFrom.valid){
         this.popLoader=true;
         this.infosecService.updateLob(this.lobconfigFrom.value,this.selectedLobId).subscribe({
          next:(response:any)=>{
             this.submitted=false;
             this.isModalVisible=false;
             this.lobconfigFrom.reset();
                // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Created Successfully', life: 3000 });
                 this.notifier.notify('default','Updated Successfully');
                 //
                // (document.getElementById("lobDetails") as HTMLElement).style.display='none';
                 this.getLob();
            },
        error:(errors:HttpErrorResponse)=>{
           this.submitted=false;
            this.popLoader=false;
            this.notifier.notify('default',errors.error['message']);
            //this.messageService.add({ severity: 'info', summary: 'info', detail: errors['error']['message'], life: 3000 });
        }})
      }
  
     }
  
     saveSICCode(){
           this.submitted=true;
           this.sicCodeconfigFrom.value['client_id']=this.client_id;
           this.sicCodeconfigFrom.markAllAsTouched();
           this.sicCodeconfigFrom.markAsDirty();
      if(this.sicCodeconfigFrom.valid){
          this.popLoader=true;
         this.infosecService.createSICCode(this.sicCodeconfigFrom.value).subscribe({
          next:(response:any)=>{
             this.submitted=false;
             this.isModalVisible=false;
              
                // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Created Successfully', life: 3000 });
                 this.notifier.notify('default','Created Successfully');
                 this.sicCodeconfigFrom.reset();
                 this.getSICCode();
            },
        error:(errors:HttpErrorResponse)=>{
           this.submitted=false;
           this.popLoader=false;
            this.notifier.notify('default',errors.error['message']);
            //this.messageService.add({ severity: 'info', summary: 'info', detail: errors['error']['message'], life: 3000 });
        }});
      }
     }
  
       updateSICCode(){
        this.submitted=true;
         this.sicCodeconfigFrom.value['client_id']=this.client_id;
         this.sicCodeconfigFrom.markAllAsTouched();
         this.sicCodeconfigFrom.markAsDirty();
      if(this.sicCodeconfigFrom.valid){
         this.popLoader=true;
        this.infosecService.updateSICCode(this.sicCodeconfigFrom.value,this.selectedSicId).subscribe({
          next:(response:any)=>{
             this.submitted=false;
             this.isModalVisible=false;
                 this.notifier.notify('default','Updated Successfully');
                this.sicCodeconfigFrom.reset();
   
                 this.getSICCode();
            },
        error:(errors:HttpErrorResponse)=>{
           this.submitted=false;
            this.popLoader=false;
            this.notifier.notify('default',errors.error['message']);
   
        }});
      }
  
     }
  
     deleteRelationship(idx:any){
      this.dialogService.openConfirmDialog('',{
              title: 'Confirm',
              message: 'Are you sure you want to delete this record?',
              btnOkText: 'Yes',
              btnCancelText: 'No',
              onClose: (data: any) => {
                if(data) {
                   this.infosecService.deleteCompanyRelationship(idx).subscribe({
                      next:(response:any)=>{
                        this.notifier.notify('default','Deleted Successfully');
                      // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully', life: 3000 });
                        this.getRelationship();
                      },
                      error:(errors:HttpErrorResponse)=>{
                        this.notifier.notify('default',errors.error['message']);
                      // this.messageService.add({ severity: 'info', summary: 'info', detail: errors['error']['message'], life: 3000 });
                      }
                    });
                }
              }})    
      
     }
  
     deleteCompany(idx:any){
      this.dialogService.openConfirmDialog('',{
              title: 'Confirm',
              message: 'Are you sure you want to delete this record?',
              btnOkText: 'Yes',
              btnCancelText: 'No',
              onClose: (data: any) => {
                if(data) {
                    this.infosecService.deleteCompanies(idx).subscribe({
                      next:(response:any)=>{
                        this.notifier.notify('default','Deleted Successfully');
                      this.getCompanyList();
                      },
                      error:(errors:HttpErrorResponse)=>{
                        this.notifier.notify('default',errors.error['message']);
                       }
                   });
                }
       }});
     }
  
      deleteLOB(idx:any){
        this.dialogService.openConfirmDialog('',{
              title: 'Confirm',
              message: 'Are you sure you want to delete this record?',
              btnOkText: 'Yes',
              btnCancelText: 'No',
              onClose: (data: any) => {
                if(data) {
                       this.infosecService.deleteLob(idx).subscribe({
                      next:(response:any)=>{
                        this.notifier.notify('default','Deleted Successfully');
                       this.getLob();
                      },
                      error:(errors:HttpErrorResponse)=>{
                        this.notifier.notify('default',errors.error['message']);
                       }
                    });
                }
        }});  
  
     }
  
       deleteSIC(idx:any){
        this.dialogService.openConfirmDialog('',{
              title: 'Confirm',
              message: 'Are you sure you want to delete this record?',
              btnOkText: 'Yes',
              btnCancelText: 'No',
              onClose: (data: any) => {
                if(data) {
                    this.infosecService.deleteSICCode(idx).subscribe({
                      next:(response:any)=>{
  
                        this.notifier.notify('default','Deleted Successfully');
                        // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully', life: 3000 });
                    this.getSICCode();
                      },
                      error:(errors:HttpErrorResponse)=>{
                        this.notifier.notify('default',errors.error['message']);
                      //this.messageService.add({ severity: 'info', summary: 'info', detail: errors['error']['message'], life: 3000 });
                      }
                    });
                }
              }});    
  
     }
  
  
     OpenModal(modal:any,type:any){
      this.seletedModal=modal;
      this.submitted=false;
      this.popLoader=false;
      this.isModalVisible = true;
      if(type=="new"){
        this.showUpdateButton = false;
        this.companyconfigFrom.reset();
              this.relationshipconfigFrom.reset();
              this.lobconfigFrom.reset();
              this.sicCodeconfigFrom.reset();
              this.companyconfigFrom.patchValue({ phone_number: '' });
              setTimeout(() => this.phoneComp.reset('US'));
      }
     }

     onInputPhoneChange(event:any){
      if(event.target.value.length > 17){
        event.preventDefault();
        let input = event.target.value;
        let formattedValue = input.slice(0,17);
        this.companyconfigFrom.controls['contact_number'].setValue(formattedValue);
      }
    }

    getLOBName(LOBids:any){
      let lobNames:any="";

      if(LOBids.length > 0){
        const result = LOBids.map((ids:any)=>this.lobListData.find((list:any)=>list['id']==ids)?.lob_name);
         lobNames = result.join(", ");
      }else{
        lobNames="-";
      }
    return lobNames;
   }
  
     closeModal(){
      this.submitted=false;
      this.popLoader=false;
      this.isModalVisible = false;
      this.companyconfigFrom.reset();
      this.relationshipconfigFrom.reset();
      this.lobconfigFrom.reset();
      this.sicCodeconfigFrom.reset();
     }
  
}
